import { addPhotozoneBackground } from '../../../components/card-editor/card-editor-utils';
import { CardContextState } from '../../../context/card-context';
import { CustomFabricImage } from '../../../global-types';
import { getObjectsByType } from '../../../utils/canvas';
import { CanvasDataTypes } from '../../../utils/canvas-utils/canvas-data-types';
import { deletePhoto } from './delete-photo';

type DeletePhotozonePhotoParams = {
  currentPhoto: fabric.Image & { data?: CustomFabricImage };
  canvas: fabric.Canvas;
  cardState: CardContextState;
  projectId: string;
  deleteImage: (projectId: string, imageName: string) => Promise<any>;
  addAction: (actionType: string, payload: any) => void;
  appDispatch: React.Dispatch<any>;
  errorTitle: string;
  errorMessage: string;
};

/**
 * Function to handle deleting a photo from a photo zone
 * @param {DeletePhotozonePhotoParams} params - The parameters for deleting a photo from a photo zone
 * @returns {Promise<void>}
 */
export async function deletePhotozonePhoto({
  currentPhoto,
  canvas,
  cardState,
  projectId,
  deleteImage,
  addAction,
  appDispatch,
  errorTitle,
  errorMessage,
}: DeletePhotozonePhotoParams) {
  // First, do the generic delete logic
  await deletePhoto({
    currentPhoto,
    canvas,
    projectId,
    deleteImage,
    addAction,
    appDispatch,
    errorTitle,
    errorMessage,
    removeActionType: 'remove-photo-from-user-zone',
  });
  // Then, add the photozone background if needed
  if (canvas && cardState) {
    addPhotozoneBackground(currentPhoto, canvas, cardState);
  }

  const currentZoneId = currentPhoto?.data?.photoZoneId;
  if (!currentZoneId) {
    return;
  }

  const photoZones = getObjectsByType(canvas, CanvasDataTypes.PhotoZone);
  const currentPhotoZone = photoZones.find((zone) => zone.data?.id === currentZoneId);
  if (currentPhotoZone) {
    currentPhotoZone.set({ visible: true });
    currentPhotoZone.data.hasContent = false;
  }
  // restore the photo zone button
  const photoButton = getObjectsByType(canvas, CanvasDataTypes.PhotoZoneButton).find(
    (button) => button.data?.photoZoneId === currentZoneId,
  );
  photoButton?.set({ visible: true });
  canvas.renderAll();
}
